import styled from 'styled-components';

export const Container = styled.div`
    padding: 8px;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    align-self: center;
    align-items: center;
`;